<section class="tabContent">
  <div class="settingsGrid">
    <pp-account-settings-options
      [ppAccount]="account"
      [ppShowHiddenOptions]="true"
    ></pp-account-settings-options>
  </div>
</section>
